import React from 'react';
import { TextField } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      width: '25ch',
    },
  },
  select: {
    '& .MuiSelect-icon': {
      color: '#3f88b1'
    }
  }
}));

function CarBodyType(props) {
  const classes = useStyles(); 
  const states = useSelector(state => {
    return state.globalStates
  })

  return(
    <div className={ classes.root }>
      <TextField
        autoComplete="on"
        id="standard-select-body-type"
        name="car_body_type"
        label="Body Type"
        value={ states.body_type ? states.body_type  : "" }
        className={ classes.select }
        InputProps={{
          readOnly: true
        }}
        InputLabelProps={{
          shrink: true
        }}
        helperText="This field is read only"
      />
    </div>
  )
}

export default CarBodyType;